export default __webpack_public_path__ + "static/media/CarImages.SedonaMedium1.745ab13c.jpg";